import { repository } from '@/api/base'

export default {
  async getSemester() {
    const { data } = await repository.get('/enums/semester/findAll')
    return data
  }
}
